<template>
  <div class="container admin-page-with-back-py">
    <div class="mb-2">
      <a class="back-button" :href="route('admin.finance-report.summary')">
        <BackIcon/>
        Back to Finance Report
      </a>
    </div>

    <div class="row">
      <div class="col-12 col-lg-8 offset-lg-2">
        <div class="row mb-5">
          <div class="col-12 text-center">
            <div class="page-title">Team Members</div>
            <div class="page-subtitle">Overview of your team task tracking hours</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <admin-staffs v-if="currentTab === 'freelancers'" key="freelancers"></admin-staffs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackIcon from '@icons/BackIcon';

export default {
  components: { BackIcon },
  props: {
    tab: {
      required: false,
      default: 'all',
    },
  },

  data () {
    return {
      currentTab: this.tab,
    };
  },
};
</script>
